import type { ModuleId } from "@server/models.ts";

export const moduleLabels: Record<ModuleId, string> = {
  employees: "Funcionários",
  "early-payments": "Vales e adiantamentos",
  erp: "Estoque",
};

const modulePathnamePrefixes: [string, ModuleId][] = [
  ["/employees", "employees"],
  ["/early-payments", "early-payments"],
  ["/reimbursements", "early-payments"],
  ["/erp", "erp"],
];

export function getModuleIdForPathname(pathname: string): ModuleId | null {
  const match = modulePathnamePrefixes.find(
    ([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
  return match?.[1] ?? null;
}
